import { useState } from 'react'

import { IconSquarePlus, IconSquareArrowUp } from '@tabler/icons-react'
import { Space, Drawer } from 'antd'
import Image from 'next/image'
import { useCookies } from 'react-cookie'
import styled from 'styled-components'

import buildPassLogo from '../../../public/icons/128x128.png'
import { Button } from '../shared-components/BUI/Button'

const CustomDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    height: auto !important;
  }

  z-index: 10000000000; // This is a hack to make sure the drawer is on top of the live chat widget
`

const MessageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: 600;
`

const MessageBody = styled.div`
  margin: 1rem 0 2rem;

  img {
    margin: 0 0.2rem;
  }

  ul {
    margin: 0;
    padding: 0 1.5rem;
  }

  li {
    list-style: circle;
    margin: 0.5rem 0;

    p {
      display: inline-flex;
      align-items: center;
      gap: 0.2rem;
      margin: 0;
    }
  }
`

const AppIcon = styled.div`
  border: 1px solid #eee;
  border-radius: 30%;
  overflow: hidden;
  flex-shrink: 0;
`

const Arrow = styled.div`
  position: absolute;
  left: 50%;
  bottom: 1rem;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-top: 14px solid #bbb;
`

export const isIpad = () =>
  navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

export const isIosDevice = () => {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document) ||
    isIpad()
  )
}

export const isSafari = () =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

export const isInStandaloneMode = () =>
  'standalone' in window.navigator && window.navigator.standalone

const PWAInstallPrompt = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [cookies, setCookie] = useCookies(['ignoreHomeScreenPrompt'])

  const handleClose = () => {
    setModalOpen(false)
    setCookie('ignoreHomeScreenPrompt', Date.now())
  }

  const hasIgnoreCookie = () => {
    // Can finetune this to re-trigger after a few days, right now
    return Boolean(cookies.ignoreHomeScreenPrompt)
  }

  const shouldDisplayPrompt =
    !hasIgnoreCookie() &&
    !modalOpen &&
    isIosDevice() &&
    isSafari() &&
    !isInStandaloneMode()

  return (
    <CustomDrawer
      open={shouldDisplayPrompt}
      placement="bottom"
      closeIcon={false}
      onClose={handleClose}
      extra={
        <Space>
          <Button variant="primary" onClick={handleClose} size="small">
            OK
          </Button>
        </Space>
      }
    >
      <MessageHeader>
        <AppIcon>
          <Image src={buildPassLogo} alt="Share Icon" height={50} width={50} />
        </AppIcon>
        Install this application on your home-screen for a better experience.
      </MessageHeader>

      <MessageBody>
        <ul>
          <li>
            <p>
              Tap <IconSquareArrowUp size={20} color="#247bd3" /> at the bottom
              of the screen.
            </p>
          </li>
          <li>
            <p>
              Tap &quot;Add to Home Screen{' '}
              <IconSquarePlus size={20} color="#555" />
              &quot;.
            </p>
          </li>
        </ul>
      </MessageBody>
      <Arrow />
    </CustomDrawer>
  )
}

export default PWAInstallPrompt
